import React from 'react'

const HorizontalLine = props => (
  <div
    className={props.color}
    style={{ height: '2px', width: props.width, margin: props.margin }}
    aria-hidden='true'
  />
)

export default HorizontalLine
